import {useQuery} from '@tanstack/react-query';
import {roleService} from '../services/role';

export function useAllRole() {
  return useQuery({
    queryKey: ['all-roles'],
    queryFn: () => roleService.getAllRoles(),
  });
}

export function useDirectoryRoles(directoryId: number | string) {
  return useQuery({
    queryKey: ['directory-roles', directoryId],
    queryFn: () => roleService.getDirectoryRoles({
      directory_id: directoryId
    }),
    enabled: directoryId != null,
  });
}